import React from "react";
import { LegalPage } from "../components/LegalPage";

// Verbatim text from the official Service Level Agreement (SLA).
// DO NOT rewrite, summarise, or paraphrase any wording below.
const sections = [
  {
    id: "sec-1",
    number: "1.",
    title: "PURPOSE",
    body: [
      {
        type: "p",
        text: "This Service Level Agreement (\u201CSLA\u201D) describes the standard support services provided by MiseOne under an active Subscription.",
      },
      {
        type: "p",
        text: "This SLA forms part of the Master Service Agreement (\u201CMSA\u201D) and should be read together with the MSA.",
      },
    ],
  },
  {
    id: "sec-2",
    number: "2.",
    title: "SUPPORT AVAILABILITY",
    body: [
      { type: "p", text: "Standard Support is provided during MiseOne Business Days." },
      {
        type: "p",
        text: "Support requests may be submitted at any time through the official support channels.",
      },
      {
        type: "p",
        text: "Requests received outside Business Hours will be reviewed on the next Business Day.",
      },
    ],
  },
  {
    id: "sec-3",
    number: "3.",
    title: "SUPPORT CHANNELS",
    body: [
      { type: "p", text: "Customers may contact MiseOne through the following support channels:" },
      {
        type: "ul",
        items: [
          "Support Email",
          "Customer Portal",
          "Official Documentation",
          "Help Centre",
        ],
      },
      { type: "p", text: "MiseOne may introduce additional support channels from time to time." },
    ],
  },
  {
    id: "sec-4",
    number: "4.",
    title: "INCIDENT PRIORITIES",
    body: [
      { type: "sub", number: "", title: "Critical" },
      {
        type: "p",
        text: "Complete loss of access to the Platform or a major production incident affecting normal business operations.",
      },
      { type: "label", text: "Target Initial Response" },
      { type: "p", text: "Within 4 Business Hours." },

      { type: "sub", number: "", title: "High" },
      {
        type: "p",
        text: "Major functionality is unavailable, but the Platform remains partially operational.",
      },
      { type: "label", text: "Target Initial Response" },
      { type: "p", text: "Within 8 Business Hours." },

      { type: "sub", number: "", title: "Medium" },
      {
        type: "p",
        text: "A feature is not operating as expected, but there is a reasonable workaround.",
      },
      { type: "label", text: "Target Initial Response" },
      { type: "p", text: "Within 2 Business Days." },

      { type: "sub", number: "", title: "Low" },
      {
        type: "p",
        text: "Minor issues, cosmetic defects, documentation requests, usability questions, or feature clarifications.",
      },
      { type: "label", text: "Target Initial Response" },
      { type: "p", text: "Within 5 Business Days." },
    ],
  },
  {
    id: "sec-5",
    number: "5.",
    title: "RESPONSE TARGETS",
    body: [
      {
        type: "p",
        text: "Response targets represent the time within which MiseOne aims to acknowledge and begin investigating a support request.",
      },
      { type: "p", text: "Response targets are objectives only." },
      { type: "p", text: "They are not guaranteed resolution times." },
    ],
  },
  {
    id: "sec-6",
    number: "6.",
    title: "PLATFORM AVAILABILITY",
    body: [
      { type: "p", text: "MiseOne is designed to operate with a high level of availability." },
      { type: "p", text: "The target service availability is:" },
      { type: "p", text: "99.9%" },
      { type: "p", text: "This target excludes:" },
      {
        type: "ul",
        items: [
          "planned maintenance;",
          "emergency maintenance;",
          "Force Majeure Events;",
          "third-party infrastructure failures;",
          "Customer internet connectivity;",
          "Customer equipment;",
          "circumstances beyond the reasonable control of MiseOne.",
        ],
      },
      {
        type: "p",
        text: "The availability target is an operational objective and does not constitute a contractual warranty or guarantee.",
      },
    ],
  },
  {
    id: "sec-7",
    number: "7.",
    title: "MAINTENANCE",
    body: [
      {
        type: "p",
        text: "Planned maintenance may be performed periodically to improve security, stability, and performance.",
      },
      { type: "p", text: "Where reasonably practicable, Customers will receive advance notice." },
      {
        type: "p",
        text: "Emergency maintenance may be carried out immediately where necessary to protect the Platform or its Users.",
      },
    ],
  },
  {
    id: "sec-8",
    number: "8.",
    title: "CUSTOMER RESPONSIBILITIES",
    body: [
      { type: "p", text: "To receive effective support, the Customer shall:" },
      {
        type: "ul",
        items: [
          "provide accurate information;",
          "describe the issue;",
          "provide screenshots where available;",
          "cooperate during troubleshooting;",
          "maintain supported browsers and devices;",
          "maintain a reliable internet connection.",
        ],
      },
    ],
  },
  {
    id: "sec-9",
    number: "9.",
    title: "EXCLUSIONS",
    body: [
      { type: "p", text: "Standard Support does not cover issues resulting from:" },
      {
        type: "ul",
        items: [
          "Customer hardware;",
          "Customer internet connection;",
          "third-party software;",
          "unauthorised modifications;",
          "misuse of the Platform;",
          "unsupported browsers;",
          "Beta Features.",
        ],
      },
    ],
  },
  {
    id: "sec-10",
    number: "10.",
    title: "ESCALATION",
    body: [
      {
        type: "p",
        text: "Where an incident requires additional technical investigation, MiseOne may escalate the issue internally until an appropriate resolution or workaround has been identified.",
      },
    ],
  },
  {
    id: "sec-11",
    number: "11.",
    title: "CHANGES TO THIS SLA",
    body: [
      {
        type: "p",
        text: "MiseOne may update this SLA from time to time to reflect improvements to the Services, support processes, or operational requirements.",
      },
      {
        type: "p",
        text: "Material changes will be communicated to Customers before taking effect where appropriate.",
      },
    ],
  },
];

export const ServiceLevelAgreement = () => (
  <LegalPage
    eyebrow="Legal"
    title="Service Level Agreement"
    sections={sections}
    testId="sla-page"
  />
);

export default ServiceLevelAgreement;
